<template>
   <div id="news-list-container" class="container">
      <div class="page-header">
         <h1>{{ $t("allNews") }}</h1>
      </div>
      
      <div class="news-grid">
         <template v-for="(news, newsIndex) in newsList">
            <div class="news-card" :key="newsIndex">
               <div class="news-image-wrapper">
                  <img :src="news.acf.common.image" alt="" />
               </div>
               <div class="news-content">
                  <span class="news-date">{{ news.acf.common.date }}</span>
                  <h3 class="news-title">
                     {{ news.acf.polylanguage[LocaleLang].title }}
                  </h3>
                  <div class="news-brief" v-html="news.acf.polylanguage[LocaleLang].brief"></div>
                  <router-link :to="'/news/' + news.slug" class="news-read-more">
                     {{ $t("readMore") }}
                  </router-link>
               </div>
            </div>
         </template>
      </div>
      
      <div v-if="newsList.length === 0" class="no-news">
         <p>{{ $t("noNewsFound") }}</p>
      </div>
   </div>
</template>

<script>
import { homepageNews } from "@/service/rest.api.js";

export default {
   name: "NewsList",
   
   data() {
      return {
         newsList: [],
         loading: true
      };
   },
   
   computed: {
      LocaleLang() {
         return this.$i18n.locale;
      }
   },
   
   mounted() {
      this.fetchAllNews();
   },
   
   methods: {
      fetchAllNews() {
         this.loading = true;
         homepageNews().then((res) => {
            this.newsList = res;
            this.loading = false;
         }).catch((error) => {
            console.error("Error fetching news:", error);
            this.loading = false;
         });
      }
   }
};
</script>

<style lang="scss" scoped>
#news-list-container {
   padding-top: 2rem;
   padding-bottom: 4rem;
   
   .page-header {
      text-align: center;
      margin-bottom: 3rem;
      
      h1 {
         font-size: 2.5rem;
         font-weight: 700;
         color: #202a38;
         margin-bottom: 1rem;
      }
   }
   
   .news-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
      gap: 2rem;
      margin-bottom: 3rem;
   }
   
   .news-card {
      border: 1px solid #e0e0e0;
      border-radius: 12px;
      overflow: hidden;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      background: white;
      
      &:hover {
         transform: translateY(-4px);
         box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
      }
      
      .news-image-wrapper {
         width: 100%;
         height: 200px;
         overflow: hidden;
         
         img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s ease;
         }
         
         &:hover img {
            transform: scale(1.05);
         }
      }
      
      .news-content {
         padding: 1.5rem;
         
         .news-date {
            color: #808080;
            font-size: 0.9rem;
            font-weight: 500;
            margin-bottom: 0.75rem;
            display: block;
         }
         
         .news-title {
            color: #202a38;
            font-size: 1.4rem;
            font-weight: 700;
            margin-bottom: 1rem;
            line-height: 1.4;
            min-height: auto;
         }
         
         .news-brief {
            color: #666;
            line-height: 1.6;
            margin-bottom: 1.5rem;
            font-size: 0.95rem;
         }
         
         .news-read-more {
            color: #33b8ff;
            text-decoration: none;
            font-weight: 500;
            display: inline-flex;
            align-items: center;
            transition: color 0.3s ease;
            
            &:hover {
               color: #2a9be6;
               text-decoration: underline;
            }
            
            &::after {
               content: "→";
               margin-left: 0.5rem;
               transition: transform 0.3s ease;
            }
            
            &:hover::after {
               transform: translateX(2px);
            }
         }
      }
   }
   
   .no-news {
      text-align: center;
      padding: 4rem 2rem;
      color: #666;
      font-size: 1.1rem;
   }
   
   @media (max-width: 768px) {
      .page-header h1 {
         font-size: 2rem;
      }
      
      .news-grid {
         grid-template-columns: 1fr;
         gap: 1.5rem;
      }
      
      .news-card .news-content {
         padding: 1rem;
         
         .news-title {
            font-size: 1.2rem;
         }
      }
   }
}
</style>